/**
 * @GENERATED from Figma node 3608:51051
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleWorkspaceDark = (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#2684FC"
      d="M10.375 6.097c0-.36-.03-.622-.094-.894H6.089v1.623h2.46c-.049.404-.317 1.012-.912 1.42l-.008.054 1.325 1.006.092.01c.843-.764 1.33-1.887 1.33-3.219"
    />
    <path
      fill="#00AC47"
      d="M6.09 10.375c1.205 0 2.217-.389 2.956-1.06l-1.409-1.07c-.377.258-.883.438-1.548.438a2.68 2.68 0 0 1-2.54-1.818l-.052.005L2.12 7.915l-.018.049a4.47 4.47 0 0 0 3.988 2.41"
    />
    <path
      fill="#FFBA00"
      d="M3.55 6.865A2.7 2.7 0 0 1 3.4 6c0-.301.055-.593.145-.865l-.003-.058-1.395-1.062-.046.021A4.3 4.3 0 0 0 1.625 6c0 .705.174 1.37.476 1.964z"
    />
    <path
      fill="#EA4335"
      d="M6.09 3.317a2.5 2.5 0 0 1 1.726.651l1.26-1.205c-.774-.705-1.781-1.138-2.987-1.138a4.47 4.47 0 0 0-3.988 2.411l1.444 1.099a2.69 2.69 0 0 1 2.544-1.818"
    />
    <path
      fill="#34A853"
      d="M20.292 9.167h1.458a.62.62 0 0 0 .625-.613V4.167l-2.083 1.53z"
    />
    <path
      fill="#4285F4"
      d="M14.25 9.167h1.458v-3.47l-2.083-1.53v4.387c0 .339.28.613.625.613"
    />
    <path
      fill="#EA4335"
      fillRule="evenodd"
      d="M15.708 5.833V3.125L18 4.792l2.291-1.667v2.708L18 7.5z"
      clipRule="evenodd"
    />
    <path
      fill="#FBBC04"
      d="M20.292 3.126v2.707l2.083-1.561v-.833a.938.938 0 0 0-1.5-.75z"
    />
    <path
      fill="#C5221F"
      d="M13.625 3.439v.833l2.083 1.561V3.126l-.583-.437a.938.938 0 0 0-1.5.75"
    />
    <path
      fill="#EA4335"
      d="M9.297 22.276c.148-.09.275-.215.363-.373l.177-.312.843-1.498c.088-.159.133-.334.133-.51H7.78l.646 1.301z"
    />
    <path
      fill="#0066DA"
      d="m1.915 21.15.425.753c.088.158.215.282.363.373l1.516-2.692H1.187c0 .175.045.35.133.509z"
    />
    <path
      fill="#00AC47"
      d="m6 16.417-1.516-2.693c-.149.09-.276.215-.364.374l-2.8 4.977c-.087.155-.132.33-.133.509H4.22z"
    />
    <path
      fill="#2684FC"
      d="M7.78 19.584H4.22l-1.517 2.692a.95.95 0 0 0 .497.136h5.6c.177 0 .348-.051.497-.136z"
    />
    <path
      fill="#00832D"
      d="m6 16.416 1.516-2.692a.95.95 0 0 0-.496-.136H4.98c-.176 0-.347.051-.496.136z"
    />
    <path
      fill="#FFBA00"
      d="m9.28 16.586-1.4-2.488a1 1 0 0 0-.364-.374L6 16.416l1.78 3.168h3.027c0-.176-.044-.351-.132-.51z"
    />
    <path
      fill="#1E88E5"
      d="m18.415 17.247.251.357.387-.28v2.028h.415v-2.666h-.348zM17.749 17.942a.74.74 0 0 0 .251-.55c0-.425-.377-.773-.83-.773-.387 0-.725.241-.812.599l.406.106c.038-.164.212-.28.405-.28.232 0 .416.154.416.348s-.184.347-.416.347h-.241v.425h.241c.261 0 .483.184.483.396 0 .222-.212.396-.473.396-.232 0-.434-.145-.463-.348l-.406.068c.068.396.444.695.879.695.492 0 .888-.367.888-.82a.8.8 0 0 0-.328-.609"
    />
    <path fill="#FBC02D" d="M20.443 22.375h-4.867v-1.941h4.867z" />
    <path fill="#4CAF50" d="M22.385 20.434v-4.868h-1.942v4.868z" />
    <path
      fill="#1E88E5"
      d="M20.443 15.566v-1.941H14.36a.734.734 0 0 0-.734.734v6.084h1.941v-4.877z"
    />
    <path fill="#E53935" d="M20.444 20.434v1.941l1.94-1.941z" />
    <path
      fill="#1565C0"
      d="M21.66 13.625h-1.216v1.941h1.94V14.35a.717.717 0 0 0-.724-.724M14.359 22.375h1.217v-1.941h-1.941v1.217c0 .405.318.724.724.724"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleWorkspaceDark);
export { ForwardRef as GoogleWorkspaceDark };
